import { Divider, Stack, Typography } from '@mui/material'
import { ReportNodeSchema } from '@ulysses-inc/harami_api_client'
import { FC } from 'react'
import getCalculateScorePercentage from 'src/exShared/hooks/reports/getCalculateScorePercentage'
import { ReportNodesDict } from 'src/exShared/types/types'
import { getDescendantNodes } from 'src/exShared/util/nodes/getDescendantNodes'
import { parseTableSection } from './parseTableSection'
import { TableSectionTable } from './TableSectionTable'

type Props = {
  /** `sectionType = TABLE` の表セクション node */
  sectionNode: ReportNodeSchema
  /** id 参照を解決するための node 辞書。 */
  nodeDict: ReportNodesDict
  isShowScore: boolean
  goPreviewPhoto: (imageUrls: string[], selectedImageIndex: number) => void
}

export const TableSection: FC<Props> = ({
  sectionNode,
  nodeDict,
  isShowScore,
  goPreviewPhoto,
}) => {
  const view = parseTableSection(sectionNode, nodeDict)

  // スコア集計はテンプレート行（列定義）を二重計上しないよう除外する。
  // 表示（parseTableSection）はテンプレート行を列定義として使うので除外しない。
  const { dictOfNode: scoredNodes } = getDescendantNodes(
    sectionNode.nodes ?? [],
    nodeDict,
    { ignoreRepeatOriginalSection: true },
  )
  const { sumAllTotalScores, sumAllResultScores, calculateScorePercentage } =
    getCalculateScorePercentage(scoredNodes)

  return (
    <Stack id={`Section-${sectionNode.id}`} sx={{ mb: 2 }}>
      <Divider />
      <Stack direction="row" alignItems="center" sx={{ height: 52 }}>
        <Typography variant="body2" sx={{ fontWeight: 700, flex: 1 }}>
          {sectionNode.section?.name}
        </Typography>
        {isShowScore && (
          <Typography component="span" variant="body2">
            {sumAllResultScores}/{sumAllTotalScores}({calculateScorePercentage}
            %)
          </Typography>
        )}
      </Stack>
      {view ? (
        <TableSectionTable view={view} goPreviewPhoto={goPreviewPhoto} />
      ) : (
        <Typography variant="body2">
          表のデータが不正なため表示できません。お問い合わせください
        </Typography>
      )}
    </Stack>
  )
}
